import React from 'react'
import './css/Style.min.css'
import './css/Responsive.min.css'
import PageTitle from './PageTitle'
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
export default function About() {
    function AchievCard(props) {
        return (
            <div className="achiev_card">
                <div>
                    <span className="number">{props.num}</span>
                </div>
                <div className="text">
                    <h3 className="achive_title">{props.title}</h3>
                </div>
            </div>
        )
    }
    function SkillCard(props) {
        return (
            <div className="col-lg-3 col-sm-4 col-6">
                <div className="skill_card card-size" >
                    <CircularProgressbar value={props.value} text={props.value + "+"} />
                    <div className="skill_name">{props.name}</div>
                </div>
            </div>
        )
    }
    function PersonalInfos(props) {
        return (
            <li><span className="title">{props.title} : </span><span className="value">{props.value}</span></li>
        )
    }
    return (
        <section id="about">
            <div className="container">
                        <PageTitle Pageinfo="Resume" Pagename="About" Highlight="Me" />
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <div className="personal_infos">
                            <h3>PERSONAL INFOS</h3>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <ul>
                                        <PersonalInfos title="First Name" value="Iftekhar" />
                                        <PersonalInfos title="Last Name" value="Hossen" />
                                        <PersonalInfos title="Age" value="15" />
                                        <PersonalInfos title="Nationality" value="Bangladeshi" />
                                        <PersonalInfos title="Freelance" value="Fiverr" />
                                    </ul>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <ul>
                                        <PersonalInfos title="Address" value="Velenagor, Narsingdi" />
                                        <PersonalInfos title="Phone" value="+8801533501236"></PersonalInfos>
                                        <PersonalInfos title="Email" value="account@911anime.com"></PersonalInfos>
                                        <PersonalInfos title="Facebook" value="Iftekhar Hossen"></PersonalInfos>
                                        <PersonalInfos title="Langages" value="English, Bangla, Hindi"></PersonalInfos>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="row achievement">
                            <div className="col-lg-6 col-6">
                                <AchievCard num="2" title="YEARS OF EXPERIENCE" />
                            </div>
                            <div className="col-lg-6 col-6">
                                <AchievCard num="20" title="COMPLETED PROJECTS" />
                            </div>
                            <div className="col-lg-6 col-6">
                                <AchievCard num="5" title="HAPPY CUSTOMERS" />
                            </div>
                            <div className="col-lg-6 col-6">
                                <AchievCard num="500" title="Working Hour" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-sm-center skills">
                    <div className="col-lg-12">
                        <div className="title">
                            <h3>MY SKILLS</h3>
                        </div>
                    </div>
                    <SkillCard value="95" name="HTML"/>
                    <SkillCard value="90" name="CSS"/>
                    <SkillCard value="80" name="SCSS"/>
                    <SkillCard value="40" name="Wordpress"/>
                    <SkillCard value="30" name="React JS"/>
                    <SkillCard value="70" name="jQuery"/>
                    <SkillCard value="70" name="jQuery"/>
                    <SkillCard value="90" name="Bootstrape"/>
                </div>
            </div>
        </section>
    )
}
